import { render, staticRenderFns } from "./FutureLayerHoveredHeaderOrFooter.vue?vue&type=template&id=36cd670b&"
import script from "./FutureLayerHoveredHeaderOrFooter.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerHoveredHeaderOrFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports